import { defineCustomElement } from "vue";
import { Register } from "..";
import F360BannerAvisoFinanceiro from "./F360BannerAvisoFinanceiro.ce.vue";

const _register: Register = {
  register() {
    if (!customElements.get("vc-banner-aviso-financeiro")) {
      const CustomElement = defineCustomElement(F360BannerAvisoFinanceiro);
      customElements.define("vc-banner-aviso-financeiro", CustomElement);
    }
  }
};

export default _register;
